import { Blocks, ChartLine, Paintbrush, Ruler, type LucideIcon } from "lucide-react";

export type PreferencesSectionId = "appearance" | "charts" | "units" | "modules";

export interface PreferencesSection {
  id: PreferencesSectionId;
  label: string;
  /** What the section holds, under its name in the nav. */
  hint: string;
  icon: LucideIcon;
  /** The section's own heading copy. */
  description: string;
}

/** The Preferences dialog's sections, in nav order. */
export const PREFERENCES_SECTIONS: readonly PreferencesSection[] = [
  {
    id: "appearance",
    label: "Appearance",
    hint: "Mode and palette",
    icon: Paintbrush,
    description: "Light or dark, and the palette the app's chrome wears.",
  },
  {
    id: "charts",
    label: "Charts",
    hint: "Colors and line weight",
    icon: ChartLine,
    description:
      "How every chart draws — in the app, and in the PDF reports you export or schedule.",
  },
  {
    id: "units",
    label: "Units",
    hint: "Electric and gas",
    icon: Ruler,
    description:
      "How electric and gas rates and usage read across the app, in exports and in the documents you generate.",
  },
  {
    id: "modules",
    label: "Modules",
    hint: "Helpers inside modules",
    icon: Blocks,
    description: "Helpers that appear inside particular modules, and where each one lives.",
  },
];
